export function faq() {
  const list = document.querySelector('.faq__list');

  if (!list) return;

  const items = list.querySelectorAll('.faq__item');

  if (!items || items.length === 0) return;

  items.forEach((item) => {
    const question = item.querySelector('.faq__question');
    const toggle = item.querySelector('.faq__toggle');
    const answer = item.querySelector('.faq__answer');
    const answerInner = item.querySelector('.faq__answer-inner');

    if (!question || !toggle || !answer || !answerInner) return;

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('is-active');

      if (isActive) {
        item.classList.remove('is-active');
        toggle.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0';
      } else {
        item.classList.add('is-active');
        toggle.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answerInner.scrollHeight + 'px';
      }
    });
  });
}
